import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../helper/apiCall';
import ENDPOINTS from '../../constants/endpoints';

// Async thunks
export const getPackages = createAsyncThunk(
    'packages/getPackages',
    async ({ studentId }, thunkAPI) => {
        try {
            const response = await client.get(`${ENDPOINTS.PACKAGES.GET_LIST}?StudentId=${studentId}`, {
                token: thunkAPI.getState().auth.token
            });
            return response.data.items || [];
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const addPayment = createAsyncThunk(
    'packages/addPayment',
    async (paymentData, thunkAPI) => {
        try {
            const response = await client.post(ENDPOINTS.PACKAGES.ADD_PAYMENT, paymentData, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const assignPackageToStudent = createAsyncThunk(
    'packages/assignPackageToStudent',
    async (assignData, thunkAPI) => {
        try {
            const response = await client.post(ENDPOINTS.PACKAGES.ASSIGN_PACKAGE_TO_STUDENT, assignData, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const updatePackage = createAsyncThunk(
    'packages/updatePackage',
    async (updateData, thunkAPI) => {
        try {
            const response = await client.put(ENDPOINTS.PACKAGES.UPDATE, updateData, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const assignBulkPackage = createAsyncThunk(
    'packages/assignBulkPackage',
    async (bulkData, thunkAPI) => {
        try {
            const response = await client.post(ENDPOINTS.PACKAGES.ASSIGN_BULK, bulkData, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const deletePackage = createAsyncThunk(  
    'packages/deletePackage',
    async (id, thunkAPI) => {
        try {
            const response = await client.delete(ENDPOINTS.PACKAGES.DELETE.replace(':id', id), null, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);


const initialState = {
    packages: [],
    loading: false,
    error: null
};

const packagesSlice = createSlice({
    name: 'packages',
    initialState,
    reducers: {
        clearPackages: (state) => {
            state.packages = [];
        },
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        // Get  packages
        builder
            .addCase(getPackages.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getPackages.fulfilled, (state, action) => {
                state.loading = false;
                state.packages = action.payload;
            })
            .addCase(getPackages.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Add payment
            .addCase(addPayment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addPayment.fulfilled, (state, action) => {
                state.loading = false;
                // Yeni ödeme eklendiğinde paket listesini güncelle
               
            })
            .addCase(addPayment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Assign package to member
            .addCase(assignPackageToStudent.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(assignPackageToStudent.fulfilled, (state, action) => {
                state.loading = false;
                // Yeni paket atandığında listeye ekle
            })
            .addCase(assignPackageToStudent.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Update package
            .addCase(updatePackage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updatePackage.fulfilled, (state, action) => {
                state.loading = false;
                // Paket güncellendiğinde listeyi güncelle
                const updatedPackage = action.payload;
                const index = state.packages.findIndex(pkg => pkg.id === updatedPackage.id);
                if (index !== -1) {
                    state.packages[index] = updatedPackage;
                }
            })
            .addCase(updatePackage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Assign bulk package
            .addCase(assignBulkPackage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(assignBulkPackage.fulfilled, (state, action) => {
                state.loading = false;
                // Toplu paket atandığında işlem tamamlandı
            })
            .addCase(assignBulkPackage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Delete package
            .addCase(deletePackage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })  
            .addCase(deletePackage.fulfilled, (state, action) => {
                state.loading = false;
            })  
            .addCase(deletePackage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { clearPackages, clearError } = packagesSlice.actions;
export default packagesSlice.reducer; 